import { ExhibitHistoryTable } from './components/ExhibitHistory/ExhibitHistoryTable';
import { ExhibitDataSection } from './components/sections/ExhibitDataSection';
import { ExhibitStructureSection } from './components/sections/ExhibitStructureSection';
import { ExhibitFootnoteSection } from './components/sections/GlobalFootnoteSection';

import { ExhibitExporterTopMenu } from 'components/ExhibitsExport/ExhibitExporterTopMenu';
import { ExhibitExportPanel } from 'components/ExhibitsExport/ExhibitExportPanel/ExhibitExportPanel';
import { Layout } from 'components/Layout';
import { ApUserRole } from 'components/RolePermission/ApUserRole';
import { ButtonMainLoader } from 'components/UIComponents/ButtonMainLoader';
import { ClaimResolutionTypeProvider } from 'providers/ClaimResolutionTypeProvider';
import './ExhibitExporterPage.css';
import {
  ExhibitExporterProvider,
  useExhibitExporterContext,
} from './providers/ExhibitExporterProvider';

export const ExhibitExporterPage = () => {
  return (
    <ClaimResolutionTypeProvider>
      <ExhibitExporterProvider>
        <ExhibitExporterView />
      </ExhibitExporterProvider>
    </ClaimResolutionTypeProvider>
  );
};

const ExhibitExporterView = () => {
  const exhibit = useExhibitExporterContext();

  const loading = exhibit.generating || exhibit.claimsLoading;

  return (
    <ApUserRole>
      <Layout>
        <ExhibitExporterTopMenu />
        <ExhibitExportPanel
          title="Claim Exhibit Exporter"
          showHistory={exhibit.historyShow}
          loading={loading}
          historyElement={<ExhibitHistoryTable />}
          onShowHistoryClick={exhibit.toggleHistoryShow}
        >
          <ExhibitDataSection />
          <ExhibitStructureSection />

          <ExhibitFootnoteSection />

          <ButtonMainLoader
            loading={exhibit.generating}
            autoFocus={false}
            disabled={!exhibit.readyToExport}
            iconName="download"
            onClick={exhibit.runExhibitExport}
          >
            {exhibit.generating
              ? 'Preparing Exhibit File'
              : 'Generate Exhibit (.xlsx)'}
          </ButtonMainLoader>
        </ExhibitExportPanel>
      </Layout>
    </ApUserRole>
  );
};
